import _ from 'lodash'
import moment from 'moment/min/moment-with-locales'
import isBrowser from './is-browser'

export default function customMoment(...args) {
  if (!isBrowser()) return moment(...args)
  let defaultUtcOffset
  try {
    defaultUtcOffset = _.get(JSON.parse(localStorage.getItem('utcOffset')), 'value')
    if (
      _.isNil(defaultUtcOffset)
      || _.isNaN(moment().utcOffset(defaultUtcOffset))
    ) return moment(...args)
    return moment(...args).utcOffset(defaultUtcOffset)
  } catch (error) {
    return moment(...args)
  }
}
